<div class="therapyContainer">
  <div class="title">
    <itl-detail-title-therapy-icon [therapyId]="prescriptionData?.therapyId"></itl-detail-title-therapy-icon>
    <div class="therapy">
      <div class="name" [style.color]="prescriptionData?.therapyId | therapyColor ">
        {{ prescriptionData?.therapyId| therapy }}
      </div>
      <div class="therapyType">{{ prescriptionData?.therapyTypeId | therapyType }}</div>
    </div>
  </div>
</div>

<itl-detail-item>
  <itl-detail-item-icon>
    <ion-icon name="alberta-activity-date"></ion-icon>
  </itl-detail-item-icon>
  <div class="scope">
    {{'prescription.create.scope' | translate}}:
    <span class="bold"
      >{{prescriptionData.startDate | date:'dd.MM.yyyy'}} - {{prescriptionData.endDate | date:'dd.MM.yyyy'}}</span
    >
  </div>
</itl-detail-item>

<div class="articleLineContainer">
  <div class="articleHeader">{{'prescription.create.listedArticles' |translate}}</div>
  <itl-warning-item *ngIf="!prescriptionData.articleLines?.length">
    <div class="warningText">{{'prescription.create.noArticles_warning' |translate}}</div>
  </itl-warning-item>
  <itl-prescription-article-data *ngFor="let articleLine of prescriptionData.articleLines" [articleLine]="articleLine">
  </itl-prescription-article-data>
</div>

<div *ngIf="prescriptionData?.notAvailableArticleLines.length" class="articleLineContainer">
  <div class="articleHeader">{{'prescription.create.unlistedArticles' |translate}}</div>
  <div class="unlistedArticleInfo">{{'prescription.create.unlistedArticles_info' |translate}}</div>
  <itl-prescription-article-data
    *ngFor="let articleLine of prescriptionData.notAvailableArticleLines"
    [articleLine]="articleLine"
  >
  </itl-prescription-article-data>
</div>

<itl-textarea
  [(ngModel)]="prescriptionData.diagnose"
  [title]="'integratedCare.diagnose' | translate"
  [placeholder]="'integratedCare.diagnose_placeholder' | translate"
  icon="alberta-diagnosis"
></itl-textarea>

<itl-info-box *ngIf="correspondenceNotVerified" [type]="InfoBoxType.Information"
  >{{ 'prescription.create.doctorNotVerified' | translate }}</itl-info-box
>

<itl-autocomplete
  [(selected)]="prescriptionData.doctorId"
  [useLogicalAnd]="true"
  [placeholder]="'prescription.create.doctor_placeholder' | translate"
  type="doctor"
  icon="alberta-doctor"
  [showDeleteButton]="false"
  [title]="'prescription.create.doctor' | translate"
  [fullPageModal]="true"
  (selectedChange)="doctorChanged($event)"
  [fullPageModal]="true"
></itl-autocomplete>
<div class="recipientData">
  <itl-selection
    [title]="'prescription.create.correspondenceType' | translate"
    [placeholder]="'prescription.create.correspondenceType_placeholder' | translate"
    [(ngModel)]="prescriptionData.correspondenceType"
    [values]="correspondenceTypes"
    icon="alberta-contact-data"
    [required]="true"
    (change)="correspondenceTypeChanged($event)"
  ></itl-selection>

  <ng-container [formGroup]="correspondenceAddressForm">
    <itl-text
      *ngIf="shouldShowCorrespondenceAddress"
      formControlName="to"
      [title]="'prescription.create.to' | translate"
      icon="alberta-address-book"
      [placeholder]="'prescription.create.to_placeholder' | translate"
      [required]="shouldShowCorrespondenceAddress"
      [(ngModel)]="prescriptionData.to"
    ></itl-text>
  </ng-container>
</div>

<div *ngIf="selectedAttachments?.length" class="selectedAttachments">
  <div class="attachmentHeader">{{ 'entities.attachment' | translate }}</div>
  <div class="attachmentSubHeader">{{ 'attachment.prescriptionRequest.infoText' | translate }}</div>
  <itl-listitem *ngFor="let attachment of selectedAttachments" [disabled]="attachment.loading">
    <itl-listitem-icon>
      <ion-icon name="alberta-fab-document"></ion-icon>
    </itl-listitem-icon>
    <itl-listitem-header>
      <span class="bold">{{ 'components.attachment.fileName' | translate }}: </span>
      {{ attachment.filename }}
    </itl-listitem-header>
    <itl-listitem-bottom-subheader>
      <div *ngIf="attachment?.createdAt">
        <span class="bold">{{ 'components.attachment.date' | translate }}: </span>
        {{ attachment.createdAt | amLocal | amDateFormat: 'lll' }}
      </div>
    </itl-listitem-bottom-subheader>
    <itl-listitem-status
      ><itl-button (click)="previewAttachment(attachment)"> <ion-icon name="alberta-preview"></ion-icon></itl-button>
      <itl-button (click)="removeAttachment(attachment)"> <ion-icon name="alberta-fab-delete"></ion-icon> </itl-button
    ></itl-listitem-status>
  </itl-listitem>
</div>

<div *ngIf="attachmentTypes?.length" class="addAttachments">
  <itl-button (click)="addAttachments()">
    <ion-icon name="alberta-add"></ion-icon>{{ 'attachment.label.title' | translate }}</itl-button
  >
</div>
